/* Certification panels: the "+" expander and the mobile dot indicator.

   Paired with snippets/certification-panels.liquid and
   assets/certification-panels.css, and used by every section that renders them.

   Two behaviours:

   1. The rows. All panels in a row toggle together, the same as the PDP's
      cert-why-section. That is deliberate rather than lazy: these sit in a
      three-up grid, and opening one panel alone drops the row's baseline and
      leaves the other two looking truncated. The markup ships collapsed and
      this script only ever opens things, so a failure here leaves the panels
      shut rather than broken, and the snippet's <noscript> block reopens them
      permanently when JS is off entirely.

   2. The dots. They follow scroll position, and tapping one scrolls to that
      panel. The scroll offset is measured from the row's own padding rather
      than assumed, because each consuming section sets its own gutter.

   Guarded with data-certp-bound so re-running is safe, and re-run on
   shopify:section:load because the theme editor re-renders a section's markup
   without re-executing an already-loaded script. */
(function () {
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-certp]:not([data-certp-bound])').forEach(function (wrap) {
      wrap.setAttribute('data-certp-bound', '');
      bindRows(wrap);
      bindDots(wrap);
    });
  }

  function bindRows(wrap) {
    var buttons = Array.prototype.slice.call(wrap.querySelectorAll('[data-certp-toggle]'));
    if (!buttons.length) return;

    var panels = buttons.map(function (btn) {
      var id = btn.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    });

    function setAll(open) {
      buttons.forEach(function (btn, i) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panels[i]) panels[i].setAttribute('aria-hidden', open ? 'false' : 'true');
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setAll(btn.getAttribute('aria-expanded') !== 'true');
      });
    });
  }

  function bindDots(wrap) {
    var row = wrap.querySelector('[data-certp-row]');
    var dots = Array.prototype.slice.call(wrap.querySelectorAll('[data-certp-dot]'));
    var items = row ? Array.prototype.slice.call(row.children) : [];
    if (!row || dots.length < 2 || dots.length !== items.length) return;

    function gutter() {
      return parseFloat(window.getComputedStyle(row).paddingLeft) || 0;
    }

    function mark(index) {
      dots.forEach(function (dot, i) {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    /* Nearest item to the scrollport's leading edge, rather than to its centre:
       the panels snap to start, so start is what the dots should report. */
    function nearest() {
      var left = row.scrollLeft + gutter();
      var best = 0;
      var bestGap = Infinity;
      items.forEach(function (item, i) {
        var gap = Math.abs(item.offsetLeft - left);
        if (gap < bestGap) {
          bestGap = gap;
          best = i;
        }
      });
      return best;
    }

    var queued = false;
    row.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
          queued = false;
          mark(nearest());
        });
      },
      { passive: true }
    );

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var target = items[i];
        if (!target) return;
        /* Measured, not assumed: offsetLeft is relative to the offset parent,
           so the two rects plus the current scroll give the true distance. */
        var delta =
          target.getBoundingClientRect().left - row.getBoundingClientRect().left - gutter();
        row.scrollTo({
          left: row.scrollLeft + delta,
          behavior: REDUCE.matches ? 'auto' : 'smooth'
        });
        mark(i);
      });
    });

    mark(nearest());
  }

  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
